import { env } from '@/config/env';

export const BACKEND_ENDPOINT: string = env.BACKEND_ENDPOINT;

export const CONTACT_EMAIL = 'hello@bliks.io';

export const SUPPORT_EMAIL = 'support@bliks.io';

export const LOCAL_STORAGE_KEYS = {
  ACCESS_TOKEN: 'access-token-v2',
  TENANT: 'tenant-v2',
  TENANT_TYPE: 'tenant-type-v2'
} as const;

// The OIDC id_token used to live here as the logout hint; it is now stored
// server-side (personal data must not sit in persistent browser storage). The
// hydrate path removes any lingering copy — see initFromStorage.
export const LEGACY_ID_TOKEN_STORAGE_KEY = 'id-token-v2';

export const welcomeSeenKey = (slug: string, userId: string) =>
  `bliks-welcome-seen-${slug}-${userId}`;

// Default review timeframe in days (used in settings page)
export const DEFAULT_REVIEW_TIMEFRAME = 30;

// Re-export entity icons
export * from './entityIcons';
